class S12wdImageGroupSection extends HTMLElement {
  connectedCallback() {
    this.initPlyrWithRetry();
  }

  initPlyrWithRetry() {
    let attempts = 0;
    const maxAttempts = 20;
    const intervalMs = 200;

    const timer = window.setInterval(() => {
      attempts += 1;
      if (this.initPlyrPlayers() || attempts >= maxAttempts) {
        window.clearInterval(timer);
      }
    }, intervalMs);
  }

  initPlyrPlayers() {
    if (!window.Plyr) return false;

    const playerNodes = this.querySelectorAll('.s1-2wd-image-group-plyr');
    if (!playerNodes.length) return true;

    playerNodes.forEach((node) => {
      if (node.dataset.plyrInited === 'true') return;

      const player = new Plyr(node, {
        muted: true,
        autoplay: true,
        controls: [],
        loop: { active: true },
        playsinline: true,
        youtube: {
          autoplay: 1,
          mute: 1,
          rel: 0,
          showinfo: 0,
          controls: 0,
        },
        quality: {
          default: 1080,
          options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240],
        },
      });

      player.on('ready', () => {
        player.muted = true;
        player.play();
      });

      node.dataset.plyrInited = 'true';
    });

    return true;
  }
}

if (!customElements.get('s1-2wd-image-group-section')) {
  customElements.define('s1-2wd-image-group-section', S12wdImageGroupSection);
}

